// extracted by mini-css-extract-plugin
export default {"validationWarningContainer":"validationWarning_validationWarningContainer__rznA-","validationWarningIcon":"validationWarning_validationWarningIcon__HByV7"};